import React, { FC, useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
import { Container } from '@src/components/Container';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import { SwitchToggle } from '@src/components/SwitchToggle';
import { useCompanyAuthCodeToggleQuery, useUpdateCompanyAuthCodeToggleMutation } from '@src/graphql/generated';
import './styles.scss';

export const Security: FC = () => {
  const [isVerificationEnabled, setIsVerificationEnabled] = useState(false);

  const { data: companyData, loading: isCompanyQueryLoading } = useCompanyAuthCodeToggleQuery();
  const [updateAuthCode] = useUpdateCompanyAuthCodeToggleMutation();

  const companyId = companyData?.company.id;

  useEffect(() => {
    if (companyData) {
      const isAuthCodeRequired = companyData?.company.isAuthCodeRequired;
      setIsVerificationEnabled(isAuthCodeRequired);
    }
  }, [companyData]);

  const saveChanges = useCallback(
    debounce((isActive: boolean, companyId?: string): void => {
      if (companyId) {
        updateAuthCode({
          variables: {
            companyId: companyId,
            updateInput: {
              isAuthCodeRequired: isActive,
            },
          },
        });
      }
    }, 300),
    [],
  );

  const onToggle = () => {
    if (companyData) {
      setIsVerificationEnabled(!isVerificationEnabled);
      saveChanges(!isVerificationEnabled, companyId);
    }
  };

  if (isCompanyQueryLoading) {
    return null;
  }

  return (
    <Container className="settings-security fade-in" type={ContainerType.BORDERED}>
      <div className="settings-security__title-wrapper">
        <SwitchToggle checked={isVerificationEnabled} onChange={() => onToggle()} />
        <h3 className="settings-security__title">Enable 2-Factor authentication</h3>
      </div>
      <p className="settings-security__text">
        Recruiters on your company account will be asked to provide an authentication code sent to their
        <br />
        email when logging in to MeetFrank.
      </p>
    </Container>
  );
};
